:root {
  --from-mobile: 26.5625em;
  --from-tablet: 40em;
  --from-desktop: 64em;
  --from-wide: 80em;
}

.slideout-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 9998;
  display: flex;
  pointer-events: auto;
  overflow: hidden;
}

.slideout-background {
  position: fixed;
  top: 0;
  left: 0;
  height: 300vh;
  width: 300vw;
  background: var(--backdrop-bgc, rgb(0, 0, 0));
  opacity: 0.1;
  z-index: 1;
}

.slideout-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-right: -20px;
  min-height: 0;
}

.scrollable-content {
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  scroll-behavior: smooth;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.scrollable-content::-webkit-scrollbar {
  width: 10px;
}
.scrollable-content::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 8px;
  background-clip: padding-box;
  border: 1px solid transparent;
}

.slideout-panel {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 320px;
  height: 100%;
  background-color: #fff;
  z-index: 9999;
  padding: 20px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}
.slideout-panel.right {
  right: 0;
  border-top-left-radius: var(--fdt-core-borderradius-large);
  border-bottom-left-radius: var(--fdt-core-borderradius-large);
  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.2);
}
.slideout-panel.left {
  left: 0;
  border-top-right-radius: var(--fdt-core-borderradius-large);
  border-bottom-right-radius: var(--fdt-core-borderradius-large);
  box-shadow: 4px 0 8px rgba(0, 0, 0, 0.2);
}

.slideout-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.slideout-footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
}

.slideout-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
}
.slideout-header h4 {
  margin-bottom: var(--fdt-core-spacing-1);
}

.slideout-close {
  margin-top: -8px;
}

.skeleton-title {
  width: 60%;
  height: 1.5rem;
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
  margin-bottom: 0.5rem;
  margin-left: 16px;
}

.slideout-skeleton {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.slideout-skeleton .skeleton-header,
.slideout-skeleton .skeleton-line,
.slideout-skeleton .skeleton-image,
.slideout-skeleton .skeleton-attribute,
.slideout-skeleton .skeleton-footer-btn {
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
}
.slideout-skeleton .skeleton-header {
  width: 60%;
  height: 24px;
}
.slideout-skeleton .skeleton-line {
  width: 100%;
  height: 16px;
}
.slideout-skeleton .skeleton-line.short {
  width: 40%;
}
.slideout-skeleton .skeleton-image {
  width: 100%;
  height: 200px;
}
.slideout-skeleton .skeleton-attribute {
  height: 20px;
  width: 80%;
}
.slideout-skeleton .skeleton-footer-btn {
  width: 100%;
  height: 40px;
}

/* Error State */
.error-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.error-state .error-message {
  padding-top: 0.8rem;
  text-align: center;
}

.divider {
  border: none;
  border-top: 1px solid var(--fdt-semantic-color-border-subtle);
  width: auto;
  margin: 0 -20px 10px;
  overflow: visible;
}

.filter-button {
  flex: 1;
  min-width: 0;
  justify-content: center;
}

.filter-buttons {
  margin-top: 10px;
}

.buttons {
  display: flex;
  gap: 12px;
  width: 100%;
}

/* Animations */
.slide-in.right {
  animation: slideInRight 0.2s ease-out forwards;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
.slide-in.left {
  animation: slideInLeft 0.2s ease-out forwards;
}

@keyframes slideInLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slideInUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
.slide-in-up {
  animation: slideInUp 0.3s ease-out forwards;
}

/* Media Queries */
@media screen and (max-width: 63.9375em) {
  .slideout-panel {
    width: 100vw;
    min-width: 100%;
    height: 100vh;
    left: 0 !important;
    right: 0 !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    overflow: hidden;
  }
  .slideout-panel.slide-in-up {
    animation: slideInUp 0.3s ease-out forwards;
  }
}
@media screen and (min-width: 64em) {
  .slideout-panel.quick-view {
    width: 420px;
  }
}
.filter-slideout .filter-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70px;
  background-color: #fff;
  z-index: 10;
  border-top: 1px solid #ccc;
  padding: 10px 20px;
  align-items: center;
}
.filter-slideout .slideout-header {
  justify-content: center;
  align-items: center;
  position: relative;
}
.filter-slideout .slideout-title {
  font-weight: normal;
  color: var(--fdt-semantic-color-foreground-default);
  text-align: center;
  flex: 1;
}
.filter-slideout .filter-slideout-body {
  margin-left: -20px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */